module.exports = __webpack_public_path__ + "img/energetic5.9616503c.jpg";